export default __webpack_public_path__ + "static/media/i23.678afd10.svg";